import { registerApplication, start } from 'single-spa'
import React from 'react'
// Error showing for react-dom
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import './index.scss'
import App from './pages/base/App'
import reportWebVitals from './reportWebVitals'
import configureStore from './redux/middleware/configureStore'
// import SystemJS from 'systemjs'

// Register micro frontends with Single SPA
// registerApplication({
// 	name: 'events', // Unique name for the micro frontend
// 	app: () => SystemJS.import('events.js'), // Path to the entry point of the micro frontend
// 	activeWhen: (location) => location.pathname.startsWith('/events'), // Route when the micro frontend should be active
// })
  
  registerApplication({
	name: 'events',
	app: () => window.System.import('events'),
	activeWhen: (location) => location.pathname.startsWith('/events')
  })
// Start Single SPA
start()
// Render the root application
const root = ReactDOM.createRoot(document.getElementById('root'))
import * as atatus from 'atatus-spa'
atatus.config('77a87ca6d6164b5487bd3bee5c84dce1').install()
root.render(
  <Provider store={configureStore()}>
    <App />
  </Provider>
)

reportWebVitals()
